import React, { useEffect, useRef } from 'react'
import Prism from 'prismjs'

const Code = ({ node }) => {
  let cpyBtn = useRef(null)
  let codeBlock = useRef(null)

  useEffect(() => {
    cpyBtn.addEventListener('click', () => {
      navigator.clipboard.writeText(node.code).then(() => {
        cpyBtn.textContent = 'Copied'
        setTimeout(() => {
          cpyBtn.textContent = 'Copy'
        }, 1000)
      })
    })
  }, [])

  useEffect(() => {
    // For syntax highlighting
    Prism.highlightAll()
  })

  return (
    <div className="code-block">
      <button
        type="button"
        id="copy-btn"
        className="copy-btn"
        ref={el => (cpyBtn = el)}
      >
        Copy
      </button>
      <pre>
        <code
          ref={el => (codeBlock = el)}
          className={`language-${
            node.language == 'text' ? 'plaintext' : node.language
          }`}
        >
          {node.code}
        </code>
      </pre>
    </div>
  )
}

export default Code
